export const SET_MODULE = "@INTEGRATION/MODULE/SET_MODULE";
export const SET_MODULE_LIST = "@INTEGRATION/MODULE/SET_MODULE_LIST";
export const SET_MODULE_VERSION = "@INTEGRATION/MODULE/SET_MODULE_VERSION";
export const SET_MODULE_INTEGRATION = "@INTEGRATION/MODULE/SET_MODULE_INTEGRATION";
export const SET_MODULE_INTEGRATION_LIST = "@INTEGRATION/MODULE/SET_MODULE_INTEGRATION_LIST";
export const SET_TRIGGER_LIST = "@INTEGRATION/MODULE/SET_TRIGGER_LIST";
